import { Modal, Select } from 'antd';
import { X } from '@phosphor-icons/react';
import { Truck } from '../../../../../../types/dbTypes';
import { unicodeToEmoji } from '../../../../../../shared/emojiUnicode';
import { useMemo } from 'react';

interface FilterModalProps {
  isVisible: boolean;
  onClose: () => void;
  trucks: Truck[];
  allTransactionCategories: any[];
  onTruckChange: (value: string) => void;
  onCategoryChange: (value: string) => void;
  onSortChange: (value: string) => void;
  onClearFilters: () => void;
  category?: string;
  truckId?: string;
  isDateDescending?: boolean;
  isAmountDescending?: boolean;
  orderBy: string;
  isPreActive: boolean;
}

function FilterModal({
  isVisible,
  onClose,
  trucks,
  allTransactionCategories,
  isDateDescending,
  isAmountDescending,
  onTruckChange,
  onCategoryChange,
  onSortChange,
  onClearFilters,
  category,
  truckId,
  orderBy,
  isPreActive,
}: FilterModalProps) {
  const formattedSortBy = useMemo(() => {
    if (orderBy === 'amount') {
      return isAmountDescending ? 'amount_desc' : 'amount_asc';
    }
    if (orderBy === 'transaction_timestamp') {
      return isDateDescending
        ? 'transaction_timestamp_desc'
        : 'transaction_timestamp_asc';
    }
    return undefined;
  }, [isAmountDescending, isDateDescending, orderBy]);

  return (
    <Modal
      title="Filter & Sort Options"
      visible={isVisible}
      onCancel={onClose}
      footer={null}
      closeIcon={<X size={20} />}
    >
      <div className="flex flex-col gap-4">
        <div>
          <label
            htmlFor="ownershipStatus"
            className="mb-1 block text-[14px] font-medium text-primary"
          >
            Filter by Truck
          </label>
          <Select
            placeholder="Select Truck"
            className="w-full disabled:cursor-not-allowed"
            onChange={(value) => onTruckChange(value)}
            value={truckId}
            disabled={isPreActive}
          >
            {trucks.map((truck) => (
              <Select.Option key={truck?.truck_id} value={truck?.truck_id}>
                {truck?.truck_display_name}
              </Select.Option>
            ))}
          </Select>
        </div>
        <div>
          <label
            htmlFor="ownershipStatus"
            className="mb-1 block text-[14px] font-medium text-primary"
          >
            Filter by Category
          </label>
          <Select
            placeholder="Select Category"
            className="w-full disabled:cursor-not-allowed"
            onChange={(value) => onCategoryChange(value)}
            value={category}
            disabled={isPreActive}
          >
            {allTransactionCategories.map((category) => (
              <Select.Option
                key={category?.categoryName}
                value={category?.categoryName}
              >
                {unicodeToEmoji(category?.emoji_unicode)}{' '}
                {category?.displayName}
              </Select.Option>
            ))}
          </Select>
        </div>
        <div>
          <label
            htmlFor="ownershipStatus"
            className="mb-1 block text-[14px] font-medium text-primary"
          >
            Sort By
          </label>
          <Select
            placeholder="select criteria"
            className="w-full disabled:cursor-not-allowed"
            onChange={(value) => onSortChange(value)}
            value={formattedSortBy || undefined}
            disabled={isPreActive}
          >
            <Select.Option value="amount_asc">Amount Ascending</Select.Option>
            <Select.Option value="amount_desc">Amount Descending</Select.Option>
            <Select.Option value="transaction_timestamp_asc">
              Date Ascending
            </Select.Option>
            <Select.Option value="transaction_timestamp_desc">
              Date Descending
            </Select.Option>
          </Select>
        </div>
        <button
          onClick={() => onClearFilters()}
          disabled={isPreActive}
          className="mt-2 rounded-md bg-gray-100 px-4 py-2 text-gray-700 transition-colors hover:bg-gray-200 disabled:cursor-not-allowed"
        >
          Clear Filters
        </button>
      </div>
    </Modal>
  );
}

export default FilterModal;
